// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"ShowMore_arrowIcon__1Lukq","active":"ShowMore_active__WOWeq","spin":"ShowMore_spin__1Ot7z","spinner-grow":"ShowMore_spinner-grow__1H_hy"};